// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","compareButton":"compareMachinesButton_compareButton__ryU8w"};